/* istanbul ignore file */
import { themes } from '@elparking/components'
import { FLAVOR } from 'commons/js/constants'

const getTheme = () => FLAVOR ? themes[FLAVOR] : themes['maggie']

export default getTheme
